// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d6_fvN9LM4Wfbw8Qg1vX{cursor:pointer;-webkit-user-select:none;user-select:none;align-items:center;gap:8px;padding-left:8px;display:inline-flex}.ZC_91y_vFKY6CbfFQIfU{padding-top:11px;padding-bottom:11px}.EbMzpu_CfQU77Do4elo0{justify-content:flex-end;gap:8px;margin-top:40px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapPlaceholder": `d6_fvN9LM4Wfbw8Qg1vX`,
	"infoAlert": `ZC_91y_vFKY6CbfFQIfU`,
	"actions": `EbMzpu_CfQU77Do4elo0`
};
export default ___CSS_LOADER_EXPORT___;
